import { GrundstueckId, GrundstueckListEntry } from '../../../core/gb-api';
import { Component, Input, OnDestroy } from '@angular/core';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { ListLoaderObservable } from '../../../shared/components/list-loader/list-loader-observable';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { AmtlicheBewertungDetailEntryMeta, AmtlichebewertungGbService } from 'app/core/amtlichebewertung-api';
import { BeschreibungTableWrapperComponent } from '../../../shared/components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktAmtlicheBewertungComponent } from '../../../shared/kompaktdarstellung/amtliche-bewertung/kompakt-amtliche-bewertung.component';
import { HistoryDirective } from '../../../shared/directives/history.directive';
import { KompaktTimepointComponent } from '../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import GrundstueckArtEnum = GrundstueckListEntry.GrundstueckArtEnum;

@Component({
  selector: 'cap-amtliche-bewertung',
  templateUrl: './amtliche-bewertung.component.html',
  styleUrls: ['./amtliche-bewertung.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    KompaktAmtlicheBewertungComponent,
    HistoryDirective,
    KompaktTimepointComponent,
    TranslatePipe
  ]
})
export class AmtlicheBewertungComponent extends AbstractComponent implements OnDestroy {
  @Input()
  art: GrundstueckArtEnum;
  @Input()
  tableFullWidth = false;
  @Input()
  hasRight = true;

  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<AmtlicheBewertungDetailEntryMeta>;
  historischeDatenSubscription;

  constructor(
    private bewertungService: AmtlichebewertungGbService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService
  ) {
    super();
    keysToTranslate<string>(['title.AmtlicheBewertung', 'Bewertung']);
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  update() {
    const timepointCtx = this.timepointService.timepointCtx;

    const observable = this.bewertungService.loadAmtlicheBewertungSichtGrundstueck(
      //
      this._grundstueckId.id, //
      timepointCtx.timepointIso, //
      timepointCtx.timepointId, //
      this.appConfigService.einstellungHistorischeDaten //
    );

    this.listLoader = new ListLoaderObservable<AmtlicheBewertungDetailEntryMeta>(undefined, 1, observable);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }
}
